"use strict";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.closest = void 0;
/** `element.matches(selector)` with a polyfill for IE */
function matches(element, selector) {
    var _a, _b, _c, _d, _e;
    return ((_e = (_b = (_a = element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector)) !== null && _b !== void 0 ? _b : (_d = (_c = element).msMatchesSelector) === null || _d === void 0 ? void 0 : _d.call(_c, selector)) !== null && _e !== void 0 ? _e : element.webkitMatchesSelector(selector));
}
/** `element.closest(selector)` with a polyfill for IE */
function closest(element, selector) {
    if (element.closest) {
        return element.closest(selector);
    }
    while (!matches(element, selector)) {
        if (element.parentElement === null) {
            return null;
        }
        element = element.parentElement;
    }
    return element;
}
exports.closest = closest;
//# sourceMappingURL=polyfill.js.map